import { render, staticRenderFns } from "./DeleteAttribute.vue?vue&type=template&id=0d1c39a6"
import script from "./DeleteAttribute.vue?vue&type=script&lang=js"
export * from "./DeleteAttribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports